import { useQuery } from 'react-query';
import { useContext } from 'react';
import { DataAccessContext, useAPI } from '@axo/shared/data-access/provider';
import { email_api } from '@axo/shared/data-access/api';
import { queryFunction } from '../../query-function.ts';
import {
  orttoCommunicationBodyKeys,
  parseOrttoCommunicationBodyKey,
} from '../../cache-keys/orttoCommunicationBodyKeys.tsx';

export function useOrttoEmailHTML(emailID: string) {
  const { state } = useContext(DataAccessContext);
  const api = useAPI();
  const cacheKey = orttoCommunicationBodyKeys.emails({
    communicationID: emailID,
  });

  return useQuery(
    cacheKey,
    queryFunction(
      email_api.getEmailHTML(api),
      ({ queryKey }) => parseOrttoCommunicationBodyKey(queryKey).communicationID
    ),
    {
      enabled: state.user.token.length > 0,
    }
  );
}
